export default [
  {
    path: '/run-tasks/body-upgrade',
    name: 'run_task_body_upgrade',
    component: () => import('../../views/run-task/BodyUpgrade.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '跑步任务',
    },
  },
  {
    path: '/run-task/cur-period',
    name: 'run_task_cur_period',
    component: () => import('../../views/run-task/CurInfo.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '跑步任务',
    },
  },

  {
    path: '/run-task/periods',
    name: 'run_task_periods',
    component: () => import('../../views/run-task/Periods.vue'),
    props: (route: any) => ({
      ...route.query,
      ...route.params,
      running_task_class_id: JSON.parse(route.query.running_task_class_id),
    }),
    meta: {
      title: '跑步打卡记录',
    },
  },
]
